import { createClient } from '@supabase/supabase-js';

// Support both CRA and Vite environment variable prefixes.
// CRA uses REACT_APP_*, Vite uses VITE_* via import.meta.env.
let supabaseUrl =
  (typeof import.meta !== "undefined" && import.meta.env && import.meta.env.VITE_SUPABASE_URL) ||
  process.env.REACT_APP_SUPABASE_URL;
let supabaseAnonKey =
  (typeof import.meta !== "undefined" && import.meta.env && import.meta.env.VITE_SUPABASE_ANON_KEY) ||
  process.env.REACT_APP_SUPABASE_ANON_KEY;

// Provide clear fallback logging if environment variables are missing
if (!supabaseUrl || !supabaseAnonKey) {
  // eslint-disable-next-line no-console
  console.error(
    'Supabase configuration missing. Ensure the appropriate environment variables are set.'
  );
  // Safe placeholders to avoid hard crash
  supabaseUrl = supabaseUrl || '';
  supabaseAnonKey = supabaseAnonKey || '';
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

